// What the re-source modal says about an OSA Gyro shot, whose candidates are
// wakes rather than gyro records. See docs/osa-shot-resourcing.md.
//
// An OSA shot is solved from a wake - a 16-record burst - so a candidate row is
// a wake identified by its offset from the matched wake (the first after the
// depth save) and by its first record. The server says which unit it is
// answering in (`Unit: 'wake'`); nothing here guesses it from the device name.

export const isWakeUnit = (data) => !!data && data.Unit === 'wake';

// +2, 0, -1: a wake's offset from the matched one.
export const wakeLabel = (offset) => `${offset > 0 ? '+' : ''}${offset}`;

// When the wake started, relative to the operator pressing Save.
export const secondsFromSave = (seconds) =>
    seconds === null || seconds === undefined ? '' : `${seconds > 0 ? '+' : ''}${Math.round(seconds)} s`;

// Stored depths carry float noise (90.19999999999999).
export const formatDepth = (depth) => Number(depth.toFixed(2)).toString();

// Why a row deserves a second look. Empty is the only one that blocks a pick;
// a shot from beside another station is offered with a warning.
export const rowNotes = (candidate, data) => {
    if (candidate.Empty) return ['tool moving'];
    const notes = [];
    if (candidate.BeforePreviousSave) {
        notes.push(data.PreviousSaveDepth !== null && data.PreviousSaveDepth !== undefined
            ? `before the ${formatDepth(data.PreviousSaveDepth)} m save`
            : 'before the previous save');
    }
    if (candidate.AtOrAfterNextSave) {
        notes.push(data.NextSaveDepth !== null && data.NextSaveDepth !== undefined
            ? `after the ${formatDepth(data.NextSaveDepth)} m save`
            : 'after the next save');
    }
    return notes;
};
